import request from '@/utils/request'

// 年份下拉框数据
export function selectYear (param) {
  return request({
    url: '/dict/public/data/list',
    method: 'get',
    params: param
  })
}

// 报修总量及占比
export function selectRepair (param) {
  return request({
    url: '/census/user/repair/percent',
    method: 'get',
    params: param
  })
}

// 年安检量占比
export function selectSecurityCheck (param) {
  return request({
    url: '/census/user/check/percent',
    method: 'get',
    params: param
  })
}

// 年安检量占比
export function selectOrderProportion (param) {
  return request({
    url: '/repairs/orderProportion',
    method: 'get',
    params: param
  })
}

// 年系统报修量占比
export function selectCategory (param) {
  return request({
    url: '/project/install/category',
    method: 'get',
    params: param
  })
}
